var intSlider1Speed = 1000;
var msTillSpeedReset = 0;
var intAutoplaySpeed = 6000;
var intTimeoutInit = 0;

$('.slider1ProductBg').css({
    transition: 'opacity ' + intSlider1Speed + 'ms ease'
});

var intCountSlides = $('.slider-1 .sliderElementOuter').length;
var intRandom = Math.floor((Math.random() * intCountSlides));

$(".slider-1").on('init', function(){
    $('#slider1ProductBg-' + intRandom).addClass('slider1ProductBgFade');
    setTimeout(function(){
        $('.isLoading').removeClass('isLoading');
    }, intTimeoutInit);
}).slick({
    dots: true,
    arrows: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    speed: intSlider1Speed,
    lazyLoad: 'ondemand',
    autoplay: true,
    autoplaySpeed: intAutoplaySpeed,
    fade: false,
    easing:'swing',
    useTransform: true,
    focusOnSelect: true,
    swipeToSlide: true,
    initialSlide: intRandom,
    prevArrow: '<a href="#" class="slick-prev"><!--&nbsp;--></a>',
    nextArrow: '<a href="#" class="slick-next"><!--&nbsp;--></a>',
    responsive: [
        {
            breakpoint: intBreakpoint,
            infinite: false,
            settings: {
                dots: true,
                arrows: false,
                speed: 500
            }
        }
        // You can unslick at a given breakpoint now by adding:
        // settings: "unslick"
        // instead of a settings object
    ]
}).on('beforeChange', function(event, slick, currentSlide, nextSlide){
    $('.slider1ProductBg').removeClass('slider1ProductBgFade');
    $('#slider1ProductBg-' + nextSlide).addClass('slider1ProductBgFade');
});
